
function TabsBlock() {
    for (let tabbed of document.querySelectorAll('.tabs-block')) {
        let tabsSlider = tabbed.querySelector('.tabs-slider');
        let tabs = tabbed.querySelector('.tabs').children;
        let panels = tabbed.querySelector('.panels').children;
        let activeTab = tabs[0];
        let activePanel = panels[0];
        for (let index = 0; index < tabs.length; index += 1) {
            let tab = tabs[index];
            let panel = panels[index];
            tab.addEventListener('click', function() {
                activeTab.removeAttribute('aria-selected');
                activeTab.classList.remove('active');
                activeTab.classList.add('inactive');
                activePanel.setAttribute('hidden', true);

                tab.setAttribute('aria-selected', 'true');
                tab.classList.remove('inactive');
                tab.classList.add('active');
                panel.removeAttribute('hidden');

                activeTab = tab;
                activePanel = panel;
                
                if (tabsSlider.scrollLeftMax !== 0) {
                    //console.log("offsetLeft: ", tab.offsetLeft);
                    //tab.offsetWidth / 2;
                    console.log({ left: tab.offsetLeft + (tabsSlider.offsetWidth - tab.offsetWidth) / 2 });
                    tabsSlider.scrollTo({ left: tab.offsetLeft - (tabsSlider.offsetWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
                    //tab.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                console.log(tabsSlider.scrollWidth, tabsSlider.scrollWidth);
            });
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', TabsBlock);
}
else {
    TabsBlock();
}
